import { useMemo } from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import type { EpgProgram } from '@jwp/ott-common/types/epg';
import useEntitlement from '@jwp/ott-hooks-react/src/useEntitlement';
import { liveChannelsURL, mediaURL, createURL } from '@jwp/ott-common/src/utils/urlFormatting';
import { getDayOptions, programIsLive, programIsUpcoming, programIsVod } from '@jwp/ott-common/src/utils/epg';

export default function useEpgData(playlist: PlaylistItem[]) {
  const dayOptions = useMemo(() => getDayOptions(), []);

  const channelEntitlements = useEntitlement(playlist);
  const areChannelsEntitled = channelEntitlements.reduce((acc, { mediaid, isEntitled }) => {
    return { ...acc, [mediaid!]: isEntitled };
  }, {} as { [mediaid: string]: boolean });

  const getPlaybackUrl = (channelId: string, program: EpgProgram, fromBeginning: boolean, view: string, offset: number | undefined) => {
    const channelItem = playlist.find(({ mediaid }) => channelId === mediaid);
    const isEntitled = channelItem && areChannelsEntitled[channelItem.mediaid];
    const isVod = programIsVod(program);
    const isUpcoming = programIsUpcoming(program);
    const isLive = programIsLive(program);

    if (isUpcoming || !isEntitled) {
      return mediaURL({ id: program.id, title: program.title });
    }

    // Initializes the player
    return createURL(liveChannelsURL(playlist[0].feedid, channelId, true, playlist[0].title), {
      start: isVod || fromBeginning ? program?.startTime : undefined,
      end: isVod ? program?.endTime : undefined,
      play: 1,
      program: !isLive ? program.id : undefined,
      beginning: fromBeginning ? '1' : undefined,
      view,
      offset: offset || undefined,
    });
  };

  return { dayOptions, getPlaybackUrl };
}
